import { CalendarClock, ClipboardCheck, Cpu, QrCode, Scale, ShieldAlert, TrendingDown, UserCheck } from 'lucide-react';
import Asistencia from '../terminal/asistencia/Asistencia';
import PasarLista from '../terminal/PasarLista';
import Baldas from '../terminal/Baldas';
import Cuarentena from '../terminal/Cuarentena';
import EntrarATerminal from '../terminal/EntrarATerminal';
import Firmware from '../terminal/Firmware';
import Planta from '../terminal/Planta';
import Sugerencias from '../terminal/Sugerencias';

/* =====================================================================
   Las pantallas del carril `terminal` · los TC-n «que son una pantalla»
   =====================================================================
   TC-14/15/18 Planta · TC-19/20 Baldas · TC-22 Cuarentena · TC-23
   Firmware · TC-25/26 Sugerencias. Van en un grupo «Planta y aparatos»
   después de las pantallas de siempre; los rangos siguen los de sus
   rutas (baldas y planta desde ENCARGADO, firmware ADMIN).
   ===================================================================== */
export default {
  orden: 45,
  grupos: [{
    grupo: 'Planta y aparatos',
    items: [
      { id: 'terminal-planta', etiqueta: 'Terminales en planta', icono: CalendarClock, min: 'CONSULTA', soloEmpresa: true, Comp: Planta },
      { id: 'terminal-baldas', etiqueta: 'Repisas con luz', icono: Scale, min: 'ENCARGADO', soloEmpresa: true, Comp: Baldas },
      { id: 'terminal-cuarentena', etiqueta: 'Lo retenido en cuarentena', icono: ShieldAlert, min: 'OPERADOR', soloEmpresa: true, Comp: Cuarentena },
      { id: 'terminal-firmware', etiqueta: 'Actualizar las terminales', icono: Cpu, min: 'ADMIN', soloEmpresa: true, Comp: Firmware },
      { id: 'terminal-sugerencias', etiqueta: 'Sugerencias de compra', icono: TrendingDown, min: 'CONSULTA', soloEmpresa: true, Comp: Sugerencias },
      // TERMINAL DE PRODUCTO F1 (DISEÑO-F1 §7, contrato v2 §3.1 y §9). El
      // QR de turno lo escanea el OPERADOR, y «Terminales de conteo» nace en
      // ENCARGADO: sin un módulo en CONSULTA el QR lo llevaría a una puerta
      // cerrada. El permiso de verdad lo pone el servidor (`terminal.operar`).
      { id: 'terminal-turno', etiqueta: 'Entrar a una terminal', icono: QrCode, min: 'CONSULTA', soloEmpresa: true, Comp: EntrarATerminal },
      // TA-4/TA-5 (DISEÑO-ASISTENCIA §8): el QR de asistencia lo escanea
      // cualquiera con `asistencia.marcar` (todas las plantillas de persona).
      { id: 'pasar-lista', etiqueta: 'Pasar lista', icono: UserCheck, permiso: 'asistencia.marcar', min: 'CONSULTA', soloEmpresa: true, Comp: PasarLista },
      { id: 'asistencia', etiqueta: 'Asistencia', icono: ClipboardCheck, permiso: 'presencia.ver', min: 'ENCARGADO', soloEmpresa: true, Comp: Asistencia },
    ],
  }],
};
